if (!customElements.get('kiwi-sale-countdown')) {
  class KiwiSaleCountdown extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.blocks = {
        days: this.querySelector('[data-kiwi-countdown-days]'),
        hours: this.querySelector('[data-kiwi-countdown-hours]'),
        minutes: this.querySelector('[data-kiwi-countdown-minutes]'),
        seconds: this.querySelector('[data-kiwi-countdown-seconds]'),
      };

      this.endTimestamp = this.parseBeijingTimestamp(
        this.dataset.endDate || '',
        this.dataset.endTime || '23:59:59'
      );

      if (!this.endTimestamp) return;

      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = window.setInterval(this.tick, 1000);
      this.initialized = true;
    }

    disconnectedCallback() {
      if (this.timer) {
        window.clearInterval(this.timer);
      }
    }

    parseBeijingTimestamp(dateText, timeText) {
      if (!dateText) return null;

      const normalizedTime = timeText && timeText.trim() ? timeText.trim() : '23:59:59';
      const withSeconds = normalizedTime.split(':').length === 2 ? `${normalizedTime}:00` : normalizedTime;
      const timestamp = new Date(`${dateText}T${withSeconds}+08:00`).getTime();

      return Number.isFinite(timestamp) ? timestamp : null;
    }

    tick() {
      const now = Date.now();
      const remaining = Math.max(0, this.endTimestamp - now);

      const dayMs = 24 * 60 * 60 * 1000;
      const hourMs = 60 * 60 * 1000;
      const minuteMs = 60 * 1000;

      const days = Math.floor(remaining / dayMs);
      const hours = Math.floor((remaining % dayMs) / hourMs);
      const minutes = Math.floor((remaining % hourMs) / minuteMs);
      const seconds = Math.floor((remaining % minuteMs) / 1000);

      this.updateBlock(this.blocks.days, days);
      this.updateBlock(this.blocks.hours, hours);
      this.updateBlock(this.blocks.minutes, minutes);
      this.updateBlock(this.blocks.seconds, seconds);

      if (remaining <= 0 && this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    updateBlock(node, value) {
      if (!node) return;
      node.textContent = String(value).padStart(2, '0');
    }
  }

  customElements.define('kiwi-sale-countdown', KiwiSaleCountdown);
}
